const PREFIX = 'schedule-calendar';

const HEADER_BAR_PREFIX = `${PREFIX}-header-bar`;
const HEADER_BAR_FILTER_PREFIX = `${PREFIX}-header-bar-filter`;

export const CALENDAR_TRACKING_IDS = {
  headerBar: {
    allAppointmentsCountButton: `${HEADER_BAR_PREFIX}-summary-box-button-all-appointments-count`,
    unconfirmedAppointmentsCount: `${HEADER_BAR_PREFIX}-summary-box-button-unconfirmed-appointments-count`,
    insuranceAlertsCount: `${HEADER_BAR_PREFIX}-summary-box-button-insurance-alerts-count`,
    dateNavigationTodayButton: `${HEADER_BAR_PREFIX}-date-navigation-today-button`,
    dateNavigationPreviousDayButton: `${HEADER_BAR_PREFIX}-date-navigation-previous-day-button`,
    dateNavigationNextDayButton: `${HEADER_BAR_PREFIX}-date-navigation-next-day-button`,
    dateNavigationDateInput: `${HEADER_BAR_PREFIX}-date-navigation-date-input`,
    dateNavigationDatePicker: `${HEADER_BAR_PREFIX}-date-navigation-date-picker`,
    locationChip: `${HEADER_BAR_PREFIX}-location-chip`,
  },
  headerBarFilter: {
    openFiltersButton: `${HEADER_BAR_FILTER_PREFIX}-open-filters-button`,
    closeFilterButton: `${HEADER_BAR_FILTER_PREFIX}:close-filter-button`,
    applyFiltersButton: `${HEADER_BAR_FILTER_PREFIX}-apply-filters-button`,
    resetFiltersButton: `${HEADER_BAR_FILTER_PREFIX}-reset-filters-button`,
    selectAllProvidersButton: `${HEADER_BAR_FILTER_PREFIX}-select-all-providers-button`,
    clearAllProvidersButton: `${HEADER_BAR_FILTER_PREFIX}-clear-all-providers-button`,
    selectAllInsuranceStatusesFilterButton: `${HEADER_BAR_FILTER_PREFIX}:insurance-statuses-filter:select-all`,
    clearAllInsuranceStatusesFilterButton: `${HEADER_BAR_FILTER_PREFIX}:insurance-statuses-filter:clear-all`,
    selectAllAppointmentTypesButton: `${HEADER_BAR_FILTER_PREFIX}:appointment-type-filter:select-all`,
    clearAllAppointmentTypesButton: `${HEADER_BAR_FILTER_PREFIX}:appointment-type-filter:clear-all`,
    selectAllOperatoriesButton: `${HEADER_BAR_FILTER_PREFIX}:operatory-filter:select-all`,
    clearAllOperatoriesButton: `${HEADER_BAR_FILTER_PREFIX}:operatory-filter:clear-all`,
    selectAllAppointmentStatusButton: `${HEADER_BAR_FILTER_PREFIX}:appointment-status-filter:select-all`,
    clearAllAppointmentStatusButton: `${HEADER_BAR_FILTER_PREFIX}:appointment-status-filter:clear-all`,
    locationAccordion: `${HEADER_BAR_FILTER_PREFIX}:location-accordion`,
    providerAccordion: `${HEADER_BAR_FILTER_PREFIX}:provider-accordion`,
    insuranceStatusAccordion: `${HEADER_BAR_FILTER_PREFIX}:insurance-status-accordion`,
    operatoryAccordion: `${HEADER_BAR_FILTER_PREFIX}:operatory-accordion`,
    appointmentTypeAccordion: `${HEADER_BAR_FILTER_PREFIX}:appointment-type-accordion`,
    appointmentStatusAccordion: `${HEADER_BAR_FILTER_PREFIX}:appointment-status-accordion`,
    appointmentStatusRadioButton: `${HEADER_BAR_FILTER_PREFIX}:appointment-status-radio-button`,
    appointmentStatusQuickFilter: `${HEADER_BAR_FILTER_PREFIX}:appointment-status-quick-filter`,
    appliedFiltersShowMoreLess: `${HEADER_BAR_FILTER_PREFIX}:applied-filters-show-more-less`,
  },
  allDayOutToggleExpandButton: `${PREFIX}:all-day-out-toggle-expand-button`,
  allDayOutEventCard: `${PREFIX}:all-day-out-event-card`,
  appointmentEventCard: `${PREFIX}:appointment-event-card`,
  outOfOfficeEventCard: `${PREFIX}:out-of-office-event-card`,
  requestEventCard: `${PREFIX}:request-event-card`,
  eventTypeSelectionModal: {
    cancelButton: `${PREFIX}:event-type-selection-modal:cancel-button`,
    selectButton: `${PREFIX}:event-type-selection-modal:select-button`,
    appointmentRadioButton: `${PREFIX}:event-type-selection-modal:appointment-radio-button`,
    outOfOfficeEventRadioButton: `${PREFIX}:event-type-selection-modal:out-of-office-event-radio-button`,
    waitlistMessageRadioButton: `${PREFIX}:event-type-selection-modal:waitlist-message-radio-button`,
  },
  scrollProvidersButton: `${PREFIX}:scroll-providers-button`,
  scrollEventsButton: `${PREFIX}:scroll-events-button`,
  zoomControls: {
    expandButton: `${PREFIX}:zoom-controls:expand-button`,
    collapseButton: `${PREFIX}:zoom-controls:collapse-button`,
  },
  emptyCalendar: {
    addProviderButton: `${PREFIX}:empty-calendar:provider-view:add-provider-button`,
    configureOperatoriesButton: `${PREFIX}:empty-calendar:operatory-view:configure-operatories-button`,
  },
};
